import { OPEN_VIEW_SEQUENCE_MODAL } from 'crm-events-data';
import { useCallback, useMemo, useState } from 'react';
import SequenceEnrollmentViewModalAsync from 'sequences-crm-events-lib/components/modals/SequenceEnrollmentViewModalAsync';
import { fetchSequenceEnrollment } from 'crm-timeline-tasks/queues/data/SequencesAPI';
import { fromJS } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
export const useViewSequenceModalActionHandler = () => {
  const [enrollment, setEnrollment] = useState(null);
  const handleViewSequenceModalAction = useCallback((actionType, data) => {
    if (actionType === OPEN_VIEW_SEQUENCE_MODAL) {
      const {
        enrollmentId
      } = data;
      fetchSequenceEnrollment(enrollmentId).then(fetchedEnrollment => {
        setEnrollment(fetchedEnrollment);
      }).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
      return;
    }
    return;
  }, []);
  const handleCloseViewSequenceModal = useCallback(() => {
    setEnrollment(null);
  }, [setEnrollment]);
  const viewSequenceModal = useMemo(() => {
    if (!enrollment) {
      return null;
    }
    return /*#__PURE__*/_jsx(SequenceEnrollmentViewModalAsync, {
      enrollment: fromJS(enrollment),
      onClose: handleCloseViewSequenceModal
    });
  }, [enrollment, handleCloseViewSequenceModal]);
  return {
    handleViewSequenceModalAction,
    viewSequenceModal
  };
};